import { Badge } from '@givebutter/primitives/badge';
import { upperFirst } from 'lodash';
import { EngageDeliveryMini, ManualItemActivity } from 'types/domain';

const hasEmailContent = (data: ManualItemActivity['data']) => {
    if (!data) return false;
    return !!(data.subject ?? data.note);
};

const getBadge = (resource: EngageDeliveryMini) => {
    if (
        resource.status === 'queued' ||
        resource.status === 'sending' ||
        resource.status === 'sent'
    ) {
        return <Badge>{upperFirst(resource.status)}</Badge>;
    } else if (resource.status === 'delivered') {
        if (resource.first_clicked_at) {
            return <Badge color="success">Clicked</Badge>;
        }
        if (resource.first_opened_at) {
            return <Badge color="success">Opened</Badge>;
        }
        return <Badge color="success">Delivered</Badge>;
    } else if (resource.status === 'failed') {
        if (resource.failed_reason === 'bounced') {
            return <Badge color="error">Bounced</Badge>;
        }
        return <Badge color="error">Failed</Badge>;
    }
    return null;
};

export { getBadge, hasEmailContent };
